// MenuPublicModal.jsx
import React from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import MenuPublicView from './MenuPublicView';
import './menu-public-view.css';

// Thin Modal wrapper — the same MenuPublicView also renders directly (no modal) on the public
// kindergarten page. Kept separate so the cabinet doesn't need to know about Modal at all.
//
// No Modal.Header — the bare header bar added nothing here. Instead the close button floats
// over the content's top-right corner, same treatment as the employee card view (TeamGallery's
// MemberModal): a small dark semi-transparent circle with a white X.
//
// z-index: this modal can be opened from ON TOP of the mobile group card, which is itself a
// full-screen sheet at z-index 10000/9999 (KindergartenGroups/index.jsx, .groupskg-sheet /
// .groupskg-sheet-overlay) — by design we don't close that sheet first (see menu-public-view.css
// for the actual values), so this modal + its backdrop need to sit above it explicitly. React-
// bootstrap's default Modal z-index (1050) would otherwise render it hidden BEHIND the sheet.
const MenuPublicModal = ({ show, onClose, kindergartenId, defaultAgeGroup }) => (
  <Modal
    show={show}
    onHide={onClose}
    size="lg"
    centered
    className="menu-public-modal"
    backdropClassName="menu-public-modal-backdrop"
  >
    <Modal.Body className="p-0 position-relative">
      <button
        onClick={onClose}
        aria-label="Закрити"
        style={{
          position: 'absolute', top: 12, right: 12, zIndex: 20,
          width: 34, height: 34, borderRadius: '50%',
          background: 'rgba(0,0,0,0.45)',
          border: 'none', cursor: 'pointer',
          color: '#fff', fontSize: 16,
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
      <MenuPublicView kindergartenId={kindergartenId} defaultAgeGroup={defaultAgeGroup} />
    </Modal.Body>
  </Modal>
);

export default MenuPublicModal;